/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const careerSiteCampaignOutputDataSchema = z.object({
	id: z.string(),
	title: z.string(),
	location: z.string().nullable(),
	formId: z.string(),
	createdAt: z.iso.datetime(),
	imageUrl: z.string().nullable(),
})

export type CareerSiteCampaignOutputDataSchema = z.infer<typeof careerSiteCampaignOutputDataSchema>
